// AUTOGENERATED FILE
// source: scripts/generate-product-types-templates.ts

import React from 'react'
import { ReactComponent as TemplateSVG } from '../../../../../assets/product-templates/svg/double-sidewall-template.svg'

export const DoubleSidewallTemplate = (
  props: React.SVGProps<SVGSVGElement>
) => {
  return <TemplateSVG {...props} />
}
